export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Jan',
    'Fév',
    'Mar',
    'Avr',
    'Mai',
    'Juin',
    'Jui',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc',
  ],
  months: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
  months_calendar: {
    January: 'Janvier',
    February: 'Février',
    March: 'Mars',
    April: 'Avril',
    May: 'Mai',
    June: 'Juin',
    July: 'Juillet',
    August: 'Août',
    September: 'Septembre',
    October: 'Octobre',
    November: 'Novembre',
    December: 'Décembre',
  },
  // weekdays
  weekdays: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  weekdays_booking_container: {
    Sunday: 'Dimanche',
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
  },
  weekdays_calendar: {
    Sun: 'dim',
    Mon: 'lun',
    Tue: 'mar',
    Wed: 'mer',
    Thu: 'jeu',
    Fri: 'ven',
    Sat: 'sam',
  },
  // additional translations
  today: "Aujourd'hui",
  tomorrow: 'Demain',
};
